import { RootState } from '../../../';

export const selectChats = (state: RootState) => state.chats.list;
export const selectChatsMeta = (state: RootState) => state.chats.listMeta;
export const selectChatsLoading = (state: RootState) => state.chats.loading.list;
export const selectSelectedChatLoading = (state: RootState) => state.chats.loading.selectedChat;
